import React, { ReactNode } from 'react';
import { Toast } from 'zarm'; // Toast队列, 使用队列的方式弹出提示信息
// 每次加入新的提示信息会在队列中对比相同的提示信息并合并  防止重复弹出
// 注: 其他 Toast 会直接顶掉ZaToast的展示
// 队列执行状态

let running = false;
const queue = [];

const toRunning = () => {
  // // console.log('消息队列queue', queue.map((item)=> item.content))
  if (running === false) {
    running = true;
    Toast.show(queue[0]);
    const timer = setInterval(() => {
      queue.shift();
      const message = queue[0];

      if (message) {
        Toast.show(queue.shift());
      } else {
        clearInterval(timer);
        running = false;
      }
    }, 2000);
  }
};

const show = props => {
  if (typeof props === 'string' || props instanceof ReactNode) {
    props = {
      content: props
    };
  } // 检查内容是否已存在


  const had = queue.findIndex(item => {
    return item.content === props.content;
  });

  if (had === -1) {
    queue.push(props);
  } // 启动队列


  toRunning();
};

const ZaToast = {
  show
};
export default ZaToast;